/******************************************************
 *                  Open-iti export
 ********************************************************/

"use strict";

import dayjs from "dayjs";

angular.module("exploitation")

	.controller("CoursesSpecialesCtrl", ["$scope", "toastr", "CoursesSpecialesService", "$controller", function ($scope, toastr, CoursesSpecialesService, $controller) {

		$controller("CoursesSpecialesCtrlParent", {$scope: $scope});

		$scope.data.courses = [];

		/**
         * Savoir si la date de service est inférieur à la date actuelle pour autoriser la modification
         * @param date
         */
		$scope.compareDateEditAccept = function (date) {
			return new dayjs(date).isAfter(dayjs());
		};

		//Initialiser à la date d'aujourd'hui
		var m = dayjs();
		m.hour(0).minute(0).second(0).millisecond(0);
		$scope.date1 = m.format();

		//Réglage du calendrier
		$scope.calendar = {
			opened: {
				start: false
			},
			dateFormat: "dd/MM/yyyy",
			dateOptions: {},
			open: function ($event, which) {
				$event.preventDefault();
				$event.stopPropagation();
				$scope.calendar.opened[which] = true;
			}
		};

		/**
         * Rafraichir les courses spéciales avec la date
         */
		$scope.refreshCoursesSpeciales = function () {
			CoursesSpecialesService.getCoursesSpeciales(convertDate($scope.date1))
				.then((response) => {
					$scope.data.courses = response.courses;
				})
				.catch((error) => {
					const data = error.data;
					var errorMessage = "Problème lors de la récupération des courses.";
					if (data !== undefined && data.message) {
						errorMessage += data.message;
					}
					toastr.error(errorMessage, "Erreur");
				});
		};
		$scope.refreshCoursesSpeciales();

		/**
         * Convertir la date dans le bon format
         * @param inputFormat
         * @returns {string}
         */
		function convertDate(inputFormat) {
			function pad(s) {
				return (s < 10) ? "0" + s : s;
			}

			var d = new Date(inputFormat);
			return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join("-");
		}

	}])
;
